import React from 'react';
import { Dialog } from './Dialog';
interface HostSalonDialogProps {
  isOpen: boolean;
  onClose: () => void;
}
export const HostSalonDialog = ({
  isOpen,
  onClose
}: HostSalonDialogProps) => {
  return <Dialog isOpen={isOpen} onClose={onClose} title="Host a Salon / Become a City Lead" size="xl" data-id="element-955">
      <div className="w-full" data-id="element-956">
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSc2pQt4IlWK2OHNjmC1_uM99NEJ2VP49XbIiIBuOKMxas42bQ/viewform?embedded=true" width="100%" height="600" frameBorder="0" marginHeight={0} marginWidth={0} data-id="element-957">
          Loading…
        </iframe>
      </div>
    </Dialog>;
};